module.exports = __webpack_public_path__ + "img/music.f1f02a8a.svg";